import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./App.js";
import "./styles/global.css";

const container = document.getElementById("root");
if (container === null) {
  throw new Error(
    'root element missing — index.html must contain <div id="root"></div>',
  );
}
createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
